export default {
  ediscovery: {
    defaultOptions: {
      offset: 0,
      size: 100,
      timeoutMs: 30000,
      types: [],
    },
  },
};
